import React from 'react'
import Container from '../../Container/Container'

function PromOrders() {
    return (
        <Container>
            <div class="nk-content ">
                  <div class="container-fluid">
                     <div class="nk-content-inner">
                        <div class="nk-content-body">
                           <div class="nk-block-head nk-block-head-sm">
						      <div class="nk-block-between">
							     <div class="nk-block-head-content">
								   <h3 class="nk-block-title page-title">Active Prom Orders</h3></div>
								   <div class="nk-block-head-content">
								    <div class="toggle-wrap nk-block-tools-toggle">
								      <div class="toggle-expand-content" data-content="pageMenu">
									    <ul class="nk-block-tools g-3">
                                            <li class="nk-block-tools-opt">
										   <a href="#" class="btn btn-primary"><span>Add Order</span></a>
                                           </li>
                                           <li><a href="" data-bs-toggle="modal" data-bs-target="#instructionModal">onloadpage open modal</a></li>
										</ul>
									  </div>
									</div>
								 </div>
							  </div>
						   </div>
						   
						<div class="card card-full">   
						  <div class="card-inner">
						   <div class="card-title-group mb-3">
						   <div class="card-tools">
							  <div class="form-control-wrap"><div class="form-icon form-icon-right"><em class="icon ni ni-search"></em></div><input type="text" class="form-control" id="default-04" placeholder="Search by keywords"/></div>
						    </div>
							<div class="card-title"><a href="" data-bs-toggle="modal" data-bs-target="#addFilterModal" class="addFilterBtn"><em class="icon ni ni-filter"></em> Add Filter</a></div>
						  </div>

                        <div className="table-responsive">  
						   <table class="table table-striped">  
						       <thead>
							    <tr>
								  <th scope="col">Acct</th>      
								  <th scope="col">Ticket</th>      
								  <th scope="col">Date</th>      
								  <th scope="col">School</th>    
								  <th scope="col">Coat</th>      
								  <th scope="col">Size</th>      
								  <th scope="col">Insleeve</th>     
                                  <th scope="col">Pant</th>      
								  <th scope="col">Hip</th>      
								  <th scope="col">Outseam</th>      
								  <th scope="col">Shirt</th>    
								  <th scope="col">Shirt size</th>      
								  <th scope="col">Vest</th>      
								  <th scope="col">Tie</th>   
                                  <th scope="col">Shoe</th>    
								  <th scope="col">Hanky</th>      
								  <th scope="col">Jewel</th>      
								  <th scope="col">Action</th> 

								</tr>  
							  </thead>  
							  <tbody>    
							    
								<tr>      
									 <th scope="row">XG</th>      
									 <td>A101</td>      
									 <td className="tableMinWidth">Jan 18, 2025</td>      
									 <td className="tableMinWidth">St. Arnold</td>    
									 <td>02</td>
									 <td>38R</td>  
    
									 <td>12.00</td>      
									 <td>123</td>      
									 <td>33</td>    
									 <td>26</td>
									 <td>310</td> 

                                     <td>14x31(S1)</td>      
									 <td>M191</td>      
									 <td>---</td>    
									 <td>BLMT</td>
									 <td>H101</td> 
                                     <td>B</td>
									 <td className="tableActionBtn">
									   <a href="" class="editPen"><em class="icon ni ni-edit-alt"></em></a>
									   <a href="" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" class="deleteTrash"><em class="icon ni ni-eye"></em></a>
									 </td>   
								 </tr> 
                                 <tr>      
									 <th scope="row">XG</th>      
									 <td>A101</td>      
									 <td className="tableMinWidth">Jan 18, 2025</td>      
									 <td className="tableMinWidth">St. Arnold</td>    
									 <td>02</td>
									 <td>38R</td>  
    
									 <td>12.00</td>      
									 <td>123</td>      
									 <td>33</td>    
									 <td>26</td>
									 <td>310</td> 

                                     <td>14x31(S1)</td>      
									 <td>M191</td>      
									 <td>---</td>    
									 <td>BLMT</td>
									 <td>H101</td> 
                                     <td>B</td>
									 <td className="tableActionBtn">
									   <a href="" class="editPen"><em class="icon ni ni-edit-alt"></em></a>
									   <a href="" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" class="deleteTrash"><em class="icon ni ni-eye"></em></a>
									 </td>   
								 </tr> 
                                 <tr>      
									 <th scope="row">XG</th>      
									 <td>A101</td>      
									 <td className="tableMinWidth">Jan 18, 2025</td>      
									 <td className="tableMinWidth">St. Arnold</td>    
									 <td>02</td>
									 <td>38R</td>  
    
									 <td>12.00</td>      
									 <td>123</td>      
									 <td>33</td>    
									 <td>26</td>
									 <td>310</td> 

                                     <td>14x31(S1)</td>      
									 <td>M191</td>      
									 <td>---</td>    
									 <td>BLMT</td>
									 <td>H101</td> 
                                     <td>B</td>
									 <td className="tableActionBtn">
									   <a href="" class="editPen"><em class="icon ni ni-edit-alt"></em></a>
									   <a href="" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" class="deleteTrash"><em class="icon ni ni-eye"></em></a>
									 </td>   
								 </tr> 
                                 <tr>      
									 <th scope="row">XG</th>      
									 <td>A101</td>      
									 <td className="tableMinWidth">Jan 18, 2025</td>      
									 <td className="tableMinWidth">St. Arnold</td>    
									 <td>02</td>
									 <td>38R</td>  
    
									 <td>12.00</td>      
									 <td>123</td>      
									 <td>33</td>    
									 <td>26</td>
									 <td>310</td> 

                                     <td>14x31(S1)</td>      
									 <td>M191</td>      
									 <td>---</td>    
									 <td>BLMT</td>
									 <td>H101</td> 
                                     <td>B</td>
									 <td className="tableActionBtn">
									   <a href="" class="editPen"><em class="icon ni ni-edit-alt"></em></a>
									   <a href="" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" class="deleteTrash"><em class="icon ni ni-eye"></em></a>
									 </td>   
								 </tr> 
                                 <tr>      
									 <th scope="row">XG</th>      
									 <td>A101</td>      
									 <td className="tableMinWidth">Jan 18, 2025</td>      
									 <td className="tableMinWidth">St. Arnold</td>    
									 <td>02</td>
									 <td>38R</td>  
    
									 <td>12.00</td>      
									 <td>123</td>      
									 <td>33</td>    
									 <td>26</td>
									 <td>310</td> 

                                     <td>14x31(S1)</td>      
									 <td>M191</td>      
									 <td>---</td>    
									 <td>BLMT</td>
									 <td>H101</td> 
                                     <td>B</td>
									 <td className="tableActionBtn">
									   <a href="" class="editPen"><em class="icon ni ni-edit-alt"></em></a>
									   <a href="" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" class="deleteTrash"><em class="icon ni ni-eye"></em></a>
									 </td>   
								 </tr> 
                                 
								
								</tbody>
							</table>
                        </div>	
							
						   </div> 
						 </div>  
						 
						 
                        </div>
                     </div>
                  </div>
               </div>



            {/* Page Onload Open Modal */}
            <div class="modal fade" tabindex="-1" id="instructionModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Instruction </h5>
                            <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <em class="icon ni ni-cross-c"></em>
                            </a>
                        </div>
                        <div class="modal-body inputCardBox">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h6 className="instructionHeading">When ordering, please note "Specialty Coats and Accessories" No BOYS sizes available. Due to limited sizes and inventory, please call customer service to place orders for the styles listed below. 
                                        <b>1-800-236-7303 </b>ext. 
                                    </h6>
                                    <ul className="listIntruction">
                                        <li>951 - MOD Starlight Lame Silver</li>
                                        <li>952 - MOD Equinox Black Velvet</li>
                                        <li>953 - MOD Starlight Lame Blue</li>
                                        <li>954 - Allure Men Venice Dusty Rose</li>
                                        <li>956 - Ike Behar Carter Red</li>
                                        <li>957 - Allure Men Venice Aubergine Velvet</li>
                                        <li>959 - MOD Camo Lame Black & Gold</li>
                                        <li>961 - MOD Starlight Lame Stone</li>
                                        <li>963 - MOD Hendrix Multi-Color</li>
                                        <li>969 - MOD Ryan Multi-Color Floral</li>
                                    </ul>

                                </div>
                                
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>   

            {/* Add Filter Modal - Remaining the same */}
            <div class="modal fade" tabindex="-1" id="addFilterModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Filters</h5>
                            <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <em class="icon ni ni-cross-c"></em>
                            </a>
                        </div>
                        <div class="modal-body inputCardBox">
                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <label>Where</label>
                                    <input type="date" class="" placeholder="Event date" />
                                </div>
                                <div class="col-md-4 mb-3 form-control-select">
                                    <label>Is</label>
                                    <select class=""><option>Select contain</option></select>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label>Date</label>
                                    <input type="date" class="" placeholder="Select date" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-4 mb-3">
                                    <button type="submit" class="addBtnCustomer">Submit</button>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <button type="submit" class="addMore">+ Add More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default PromOrders
